import React from 'react'

interface DebugToolErrorBoundaryProps {
  children: React.ReactNode
  fallback?: React.ReactNode
}

interface DebugToolErrorBoundaryState {
  hasError: boolean
}

export class DebugToolErrorBoundary extends React.Component<DebugToolErrorBoundaryProps, DebugToolErrorBoundaryState> {
  state: DebugToolErrorBoundaryState = { hasError: false }

  static getDerivedStateFromError(): DebugToolErrorBoundaryState {
    return { hasError: true }
  }

  componentDidCatch() {
    // Intentionally no-op. The goal is to prevent DebugTool from breaking the app.
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? null
    }

    return this.props.children
  }
}

